const engageFeatures = [
   {
      key: 'messaging',
      title: 'Groups and Direct Messaging',
      description:
         'Direct messages and Groups empower members to connect more personally and meaningfully. Whether it’s through one-on-one engagements, spontaneous collaborations, or deep dives in focused group spaces.',
      icon: 'chat'
   },
   {
      key: 'forums',
      title: 'Forums and Polls',
      description:
         'Create Forums for your community members to engage in rich discussions, exchange ideas, ask questions, share their thoughts and create polls to gather broad feedback and insights.',
      icon: 'discuss'
   },
   {
      key: 'blog',
      title: 'Pages and Blogs',
      description:
         'Communities includes a powerful Content Management System that lets you share highly customizable content and news to keeps members informed and engaged.',
      icon: 'file'
   },
   {
      key: 'marketplace',
      title: 'Marketplace and Resources',
      description:
         'Marketplace let you create a hub and repository for your community members to share and exchange valuable resources, files and tools. Marketplaces are a powerful way for community members to engage and provide support to their peers.',
      icon: 'marketplace'
   },
   {
      key: 'profile',
      title: 'Profiles, Directories and Badges',
      description:
         'Community members can create profiles, share their interests, and connect with others in the community. Directories and badges are a great way to showcase your community members and their contributions.',
      icon: 'user'
   }
]

const eventFeaures = [
   {
      key: 'events',
      title: 'Events and Broadcasts',
      description:
         'Communities is designed to help you connect your community members both online and offline. Create both online and offline events and broadcasts to keep your community engaged and connected.',
      icon: 'event'
   },
   {
      key: 'payments',
      title: 'Payments and Tickets',
      description:
         'Communities includes a comprehensive system to handle payments, ticketing, discounts and more for your events.',
      icon: 'payments'
   },
   {
      key: 'forms',
      title: 'Registration Forms',
      description:
         'Create highly customizable registration forms for your events to collect important information from your community members.',
      icon: 'form'
   },
   {
      key: 'checkin',
      title: 'Check-in Desk',
      description:
         'Communities includes a Check-in Desk tool to help you manage member attendance and on-site registration at your events.',
      icon: 'checkin'
   },
   {
      key: 'liveevents',
      title: 'Live Event Tools',
      description: 'For live events, use the Communities live discussion and polling tools. These tools allow you to gather real-time thoughts and feedback from audience members and are a great way to encourage engagement and participation.',
      icon: 'schedule'
   }
]

const adminFeatures = [
   {
      key: 'theme',
      title: 'Theming and Branding',
      description:
         'Communities is a highly customizable platform that lets you design your community to match the look and feel of your brand. The platform includes a wide range of themes and templates to choose from. If needed, we can work with you to customize your community from the ground up.',
      icon: 'theme'
   },
   {
      key: 'analytics',
      title: 'Analytics and Reports',
      description:
         'Communities provides a comprehensive set of analytics and reporting tools to help you understand your community and how it is performing.',
      icon: 'analytics'
   },
   {
      key: 'integrations',
      title: 'Integrations',
      description:
         'Communities integrates with a wide range of popular third party apps and services that easily plug into your community.',
      icon: 'integrations'
   },
   {
      key: 'email',
      title: 'Email Digests and Newsletters',
      description:
         'Create and manage branded, custom email notifications, newsletters and digests that are sent out to your community members. Communities also provides email activity and analytics tools. No need for a seperate email marketing tool.',
      icon: 'email'
   },
   {
      key: 'privacy',
      title: 'Advanced Privacy controls',
      description:
         'Communities provides highly sophisticated privacy controls to help you manage visiblity and access for content throughout your community. Privacy controls can be applied in a granular way to specific content, groups, forums, pages, and more.',
      icon: 'privacy'
   }
]

export {
   engageFeatures,
   eventFeaures,
   adminFeatures
}
